/* Ayudate · Tipos de cuenta para depositarle sus pagos a un tutor
   Reemplaza el registro de SINPE Móvil (un enlace aparte después de la
   aprobación) por transferencia bancaria directa, pedida de una vez en el
   propio formulario de registro (ver FormTutor.jsx). BCR, BAC y Wink ya
   eran los tres bancos a los que Ayudate transfería directamente por IBAN;
   el id "iban" cubre cualquier otro banco costarricense, vía SINPE Móvil. */

export const TIPOS_CUENTA = [
  { id: "bcr", nombre: "BCR (IBAN)" },
  { id: "bac", nombre: "BAC (IBAN)" },
  { id: "wink", nombre: "Wink (IBAN)" },
  { id: "iban", nombre: "SINPE Móvil" },
];

export const NOMBRE_TIPO_CUENTA = Object.fromEntries(TIPOS_CUENTA.map((t) => [t.id, t.nombre]));
